import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import { ActionsheetContent, ActionsheetWrapper } from 'components/action-sheet';

import { ContentHeader, ContentText, ContentWrapper } from './styled';

interface IDialogActionSheetProps {
  isOpen?: boolean;
  onDismiss: () => void;
  onConfirm?: () => void;
  confirmButtonLabel?: string;
  dismissButtonLabel?: string;
  title: string;
  body: string;
}

export const DialogActionSheet = ({
  isOpen = true,
  onDismiss,
  onConfirm,
  confirmButtonLabel,
  dismissButtonLabel,
  title,
  body,
}: IDialogActionSheetProps) => {
  const { formatMessage } = useIntl();
  const shouldShowConfirm = !!onConfirm && !!confirmButtonLabel;

  return (
    <ActionsheetWrapper onOpenEventMessage={title} isOpen={isOpen} onClose={onDismiss}>
      <ActionsheetContent>
        <ContentWrapper>
          <ContentHeader>{title}</ContentHeader>
          <ContentText>{body}</ContentText>
          {shouldShowConfirm && (
            <ActionButton onPress={onConfirm}>{confirmButtonLabel}</ActionButton>
          )}
          <ActionButton onPress={onDismiss} variant={ActionButtonVariants.TEXT_ONLY}>
            {dismissButtonLabel || formatMessage({ id: 'cancel', description: 'cancel label' })}
          </ActionButton>
        </ContentWrapper>
      </ActionsheetContent>
    </ActionsheetWrapper>
  );
};
